import { useConfirm, type UseConfirmOptions } from './use-confirm';

/**
 * Price changed confirm hook
 *
 * Business Rule:
 * - Users must confirm after CMS updates price change content
 * - The dateToCheck should be the CMS content's updatedAt timestamp
 * - If lastConfirmedAt is before the CMS update time, show modal
 */
export const usePriceChangedConfirm = (
  options: Omit<UseConfirmOptions, 'storageKey'>
) =>
  useConfirm({
    ...options,
    storageKey: 'price_changed_confirm',
  });
